import { render, staticRenderFns } from "./PCCLocationMapping.vue?vue&type=template&id=1a642b70"
import script from "./PCCLocationMapping.vue?vue&type=script&lang=js"
export * from "./PCCLocationMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports